import { useEffect } from 'react';
import React from 'react';

import { waitForFn } from '@lyearn/core/utils/function';
import { UploadedFile, UppyFileMeta } from '@lyearn/shared/hooks/useUppy';

import { setTextareaHeight } from '../components/ResizeContainer/utils';

export type FileType = UploadedFile<UppyFileMeta & { shortId: string }> & { url?: string };

const useResizableTextArea = (text?: string) => {
  const textAreaInputRef = React.useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (text === null) {
      return;
    }

    // textAreaInputRef gets attached to pm_reactComponent but is not render on dom yet so size might be not available
    // so added waitForFn;
    if (textAreaInputRef.current?.scrollHeight === 0) {
      return waitForFn(
        // Editor might be in suspense which applies display none to container and render on dom
        // as element is not drawn(due to display none) styles will be not available
        // thus waitFor checks if styles is ready
        () => textAreaInputRef.current?.scrollHeight !== 0 && textAreaInputRef.current,
        () => {
          setTextareaHeight(textAreaInputRef.current);
        },
      );
    }
    setTextareaHeight(textAreaInputRef.current);
  }, [text]);

  return { textAreaInputRef };
};

export default useResizableTextArea;
